export default __webpack_public_path__ + "static/img/pending_return.757598a.svg";